export default {"src":"/newStatic/_next/static/media/reddit.a01ff763.svg","height":18,"width":20};